import { StarIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

interface TestimonialCardProps {
  stars?: number;
  quote: string;
  author: string;
  className?: string;
}

/**
 * Testimonial card component displaying customer reviews with star ratings.
 * Used in onboarding and other promotional contexts.
 */
const TestimonialCard = ({
  stars = 5,
  quote,
  author,
  className = "",
}: TestimonialCardProps) => {
  return (
    <div
      className={clsx(
        "TestimonialCard",
        "rounded-2xl border border-zinc-200 bg-white p-6 font-body shadow-sm",
        className
      )}
    >
      <div className="mb-3 flex gap-1 text-amber-500">
        {Array.from({ length: stars }).map((_, i) => (
          <StarIcon key={i} className="h-5 w-5 fill-current" />
        ))}
      </div>
      <blockquote className="mb-4 text-black">
        <p className="text-sm font-medium">&ldquo;{quote}&rdquo;</p>
      </blockquote>
      <div className="text-xs font-medium text-zinc-900">{author}</div>
    </div>
  );
};

export default TestimonialCard;
